<template>
    <span>
        <template v-if="session.state === 'CANCELLED'">
            <span class="mx-1">–</span> <strong>Annulée</strong>
        </template>
        <template v-else-if="session.state === 'POSTPONED'">
            <span class="mx-1">–</span> <strong>Reportée</strong>
        </template>
        <template v-if="session.state_detail">
            <span class="cursus-content cursus-content--muted small" v-html="session.state_detail"></span>
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            session: Object,
        }
    }
</script>
